import axios from 'axios'
import ApiService from '@/common/api.service'
import { API_URL } from '@/common/config'

// Used for genuinely public, unauthenticated endpoints (anonymous registration/ARMS-invitee
// visitors have no session at all). Deliberately not the shared ApiService/Vue.axios instance:
// its Authorization header can carry a stale value from unrelated browser state, which the
// backend would try to parse regardless of the endpoint, 401 on, and trigger an unwanted
// refresh-then-forced-logout for. A fresh, header-free instance sidesteps that entirely.
const publicAxios = axios.create({ baseURL: API_URL })

export default {
  create (data) {
	return new Promise((resolve, reject) => {
	  ApiService.post('/member/create', data).then(response => {
		resolve(response)
	  }).catch(error => {
		reject(error)
	  })
	})
  },
  changePass (data) {
	return new Promise((resolve, reject) => {
		ApiService.post('/member/changePass', data).then(response => {
			resolve(response)
		}).catch(error => {
			reject(error)
		})
	})
  },
  acceptTerms (data) {
    return new Promise((resolve, reject) => {
      ApiService.post('/member/accept-terms', data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  sendOtc (data) {
    return new Promise((resolve, reject) => {
      ApiService.post('/member/otc/send', data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  verifyIdentity (data) {
    return new Promise((resolve, reject) => {
      ApiService.post('/member/identity-verification/verify', data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  updateIdentityContact (data) {
    return new Promise((resolve, reject) => {
      ApiService.post('/member/identity-contact/verify', data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  withdraw () {
    return new Promise((resolve, reject) => {
      ApiService.post('/member/withdraw', null).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  logout () {
    return new Promise((resolve, reject) => {
      ApiService.post('/member/logout', null).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  validateDuplicate (data) {
    return new Promise((resolve, reject) => {
      ApiService.post('/member/validateDuplicateUser', data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  checkRegistrationCollision (code) {
    return new Promise((resolve, reject) => {
      publicAxios.post('/member/registrationCollisionCheck', { code }).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
    // getMemberInfoFromUrlToken/editMemberArms/checkArmsEditCollision are all genuinely
    // unauthenticated (anonymous, not-yet-registered ARMS invitee) endpoints, so they use the
    // same header-free publicAxios instance as checkRegistrationCollision above.
    getMemberInfoFromUrlToken (token) {
        return new Promise((resolve, reject) => {
            publicAxios.get('/member/arms-info/token', { params: { token } }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    editMemberArms (token, data) {
        return new Promise((resolve, reject) => {
            publicAxios.post('/member/arms-edit?token=' + token, data).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    checkArmsEditCollision (token) {
        return new Promise((resolve, reject) => {
            publicAxios.post('/member/arms-edit/collisionCheck', { token }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getLoginUserInfo () {
      return new Promise((resolve, reject) => {
          ApiService.get('/member/selfInfo').then(response => {
              resolve(response.data)
          }).catch(err => {
              reject(err)
          })
      })
    }
}
